import { Loading } from "@/components/atoms";
import { useGetCountriesQuery } from "@/redux/apis/resource/resourceApi";
import { useLegacySiteConfig } from "./hooks/useLegacySiteConfig";
import { useRMConfig } from "./hooks/useRMConfig";

const hasRMConfig = window.rm && window.rm.config;

export const ConfigProvider = ({ children }: React.PropsWithChildren) => {
  /**
   * Warm the country reference data for the whole app in one place — this provider wraps the public
   * container, the private container and all three onboarding flows.
   *
   * Deliberately NOT part of the isReady gate below: country config has bundled defaults, so
   * blocking the first paint on it would trade a correct render for a slower one.
   */
  useGetCountriesQuery();

  if (hasRMConfig) return <RMConfigProvider>{children}</RMConfigProvider>;
  return <LegacyConfigProvider>{children}</LegacyConfigProvider>;
};

const LegacyConfigProvider = ({ children }: React.PropsWithChildren) => {
  const { isReady } = useLegacySiteConfig();

  return isReady ? <>{children}</> : <Loading />;
};

const RMConfigProvider = ({ children }: React.PropsWithChildren) => {
  const { isReady } = useRMConfig();

  return isReady ? <>{children}</> : <Loading />;
};
